import { useParams, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Fragment, useEffect, useState, useRef } from "react";
import { Accordion, Button, Card, Form, Modal } from "react-bootstrap";
import { addNewCommand, getCommand, getCommandByAttachmentID } from "../store/api/CommandsAPI";
import Loader from "react-loader-spinner";
import { PlusCircle, X, Link45deg, PersonCircle, Trash, PersonLinesFill, Check2, Check2Square } from "react-bootstrap-icons";
import { setUserPop, setSelectedUserPop } from "../store/api/Users";
import DatePicker from "react-datepicker2";
import momentJalaali from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import ModalSelectUser from "../Components/ModalSelectUser";
import ModalSelectedUserStatus from "../Components/ModalSelectedUserStatus";
import { attachFile, downloadFile } from "../store/api/Services";
import { addNewMessage, deleteMessage, editCommand, doneCommand } from "../store/api/CommandsAPI";
import { setDialog } from "../store/api/GetAllProduct";

const Commands = () => {
    const { commandID, attachmentType, attachmentID } = useParams();
    let command = useSelector(state => state.CommandsReducer.currentCommand);
    const history = useHistory();
    const messageData = useRef({});
    const commandData = useRef({});
    const messageAttachment = useRef();
    const commandAttachment = useRef();
    const [err, setError] = useState({});
    const currCommandID = useRef(commandID);
    const [showNew, setNewShow] = useState(false);
    const [messageCount, setMessageCount] = useState(command && command.CommandMessages ? command.CommandMessages.length : 0);
    commandData.current.AlarmDate = momentJalaali();
    commandData.current.CommandRecipients = [];
    const back = () => {
        history.goBack();
    }
    const selectRecipents = (list) => {
        list.forEach(l => {
            commandData.current.CommandRecipients.push({ RecipientID: l });
        });
    }
    const addMessage = () => {
        let f = messageAttachment.current.files;
        if (!messageData.current.Message) {
            alert("متن پیام وارد نشده است");
        }
        if (f.length > 0) {
            attachFile(messageAttachment.current, currCommandID.current, "command", () => dispatch(getCommand(currCommandID.current)), messageData.current.Message);
        }
        else {
            messageData.current.CommandID = currCommandID.current;
            dispatch(addNewMessage(messageData.current, () => dispatch(getCommand(currCommandID.current))));
        }
        setNewShow(false);
    }
    const attachNewFile = (id) => {
        let f = commandAttachment.current.files;
        if (f.length > 0) {
            attachFile(commandAttachment.current, id, "command", () => { history.replace("/Services/Commands/" + id + "/" + attachmentID + "/" + attachmentType); dispatch(getCommand(id, initCommand)); }, "AddCommand");
        }
        else {
            history.replace("/Services/Commands/" + id + "/" + attachmentID + "/" + attachmentType);
            dispatch(getCommand(id, initCommand));
        }
    }
    const showUserPop = () => {
        if (currCommandID.current === "0") {
            dispatch(setUserPop({ show: true, selectUser: selectRecipents }));
        }
        else {
            dispatch(setSelectedUserPop({ show: true, userList: command.Recipients }));
        }
    }
    const changeCommand2Done = () => {
        dispatch(doneCommand(currCommandID.current, () => dispatch(getCommand(currCommandID.current, initCommand))));
    }
    const saveCommand = () => {
        let subjectIsEmpty = !commandData.current.Subject || commandData.current.Subject === "";
        let messageIsEmpty = !commandData.current.Message || commandData.current.Message === "";
        let alarmDateIseEMpty = currCommandID.current === "0" && (!commandData.current.AlarmDate || commandData.current.AlarmDate === "");
        let recipientIsEmpty = currCommandID.current === "0" && (!commandData.current.CommandRecipients || commandData.current.CommandRecipients.length === 0);
        let priorityIsEmpty = !commandData.current.Priority || commandData.current.Priority === "";

        setError({
            Subject: subjectIsEmpty ? "N" : null,
            Message: messageIsEmpty ? "N" : null,
            Alarm: alarmDateIseEMpty ? "N" : null,
            Recipients: recipientIsEmpty ? "N" : null,
            Priority: priorityIsEmpty ? "N" : null
        });
        if (subjectIsEmpty || messageIsEmpty || alarmDateIseEMpty || recipientIsEmpty || priorityIsEmpty) {
            return;
        }
        if (attachmentID && attachmentID !== "0") {
            commandData.current.AttachmentID = attachmentID;
        }
        if (attachmentType && attachmentType !== "0") {
            commandData.current.AttachmentType = attachmentType;
        }
        if (currCommandID.current !== "0" && commandData.current.AlarmDate === momentJalaali().local("en").format("YYYY/MM/DD HH:mm")) {
            commandData.current.AlarmDate = command.AlarmDate
        }
        if (currCommandID.current !== "0") {
            dispatch(editCommand(commandData.current));
        }
        else {
            commandData.current.CommandMessages = [];
            let attachFileName = "";
            if (commandAttachment.current.files.length > 0) {
                attachFileName = commandAttachment.current.files[0].name;
            }
            commandData.current.CommandMessages.push({ Message: commandData.current.Message, AttachmentFileName: attachFileName });
            dispatch(addNewCommand(commandData.current, attachNewFile));
        }

    }
    const initCommand = (cmd) => {
        commandData.current.Message = cmd.Message;
        commandData.current.Subject = cmd.Subject;
        commandData.current.MessageID = cmd.CommandMessageID;
        commandData.current.Priority = cmd.Priority;
        commandData.current.CommandID = cmd.ID;
        if (cmd.ID && cmd.ID !== "0") {
            currCommandID.current = cmd.ID.toString();
        }
    }
    const onDeleteSuccess = (id) => {
        const removedList = command.CommandMessages.slice();
        command.CommandMessages = "PENDING";
        setMessageCount(-1);
        command.CommandMessages = removedList.filter(m => m.ID !== id);
        setMessageCount(-2);
    }
    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList = "notMain";
        if (commandID && commandID !== "0") {
            dispatch(getCommand(commandID, initCommand));

        }
        else if ((!commandID || commandID === "0") && (attachmentID && attachmentID !== "0")) {
            dispatch(getCommandByAttachmentID(attachmentID, attachmentType, initCommand));
        }
        else {
            dispatch(getCommand(-1));
        }
    }, []);
    return (
        <Modal className={currCommandID.current !== "0" && command?.CommandMessages && command?.CommandMessages.length > 0 ? "superwide-dialog" : "wide-dialog"} show={true}>
            <Modal.Header className="headerStyle">ثبت/ویرایش دستور کار<span onClick={back} style={{ cursor: "pointer" }}><X size={24} /></span></Modal.Header>
            <Modal.Body className="bodyStyle" style={{ textAlign: "right" }}>
                <ModalSelectUser />
                <ModalSelectedUserStatus />
                <input type='hidden' value={messageCount} readOnly />
                {command === "PENDING" &&
                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={40} />
                }
                {command !== "PENDING" &&
                    <Fragment>
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "#b6b6b6", textAlign: "right", fontSize: "14px" }}>شرح دستور کار</Accordion.Toggle>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body style={{ textAlign: 'right' }}>


                                        {currCommandID.current !== "0" &&
                                            <div>
                                                <label style={{ color: "blue", fontSize: "12px" }}>{currCommandID.current === "0" || !command ? "" : "تاریخ ایجاد: " + command.pCreationDate}</label>
                                                <label style={{ color: "blue", fontSize: "12px", float: "left" }}>{currCommandID.current === "0" || !command ? "" : "ایجاد کننده: " + command.CreateByName}</label>
                                            </div>
                                        }
                                        <div className="row">
                                            <div className="form-group col-md-4">
                                                <label>تاریخ نمایش</label>
                                                <DatePicker name="AlarmDate" isGregorian={false} timePicker={true} className="form-control"
                                                    value={currCommandID.current !== "0" && command && command.AlarmDate ? momentJalaali(command.AlarmDate)
                                                        : momentJalaali()}
                                                    onChange={value => { commandData.current.AlarmDate = value.local("en").format("YYYY/MM/DD HH:mm") }} />
                                                {err.AlarmDate && <small className="errors">تاریخ نمایش الزامی است</small>}
                                            </div>
                                            <div className="form-group col-md-4 col-sm-3 col-xs-3">
                                                <label>اولویت</label>
                                                <select className="form-control" defaultValue={currCommandID.current === "0" || !command ? "" : command.Priority}
                                                    onChange={(e) => commandData.current.Priority = e.target.value}>
                                                    <option value="">انتخاب کنید</option>
                                                    <option value={1}>پایین</option>
                                                    <option value={2}>عادی</option>
                                                    <option value={3}>بالا</option>
                                                    <option value={4}>خیلی فوری</option>
                                                </select>
                                                {err.Priority && <small className="errors">انتخاب اولویت الزامی است</small>}
                                            </div>
                                            {currCommandID.current === "0" && (!command?.AttachmentFileName || command?.AttachmentFileName.length === 0) &&
                                                <div className="col-md-4 form-group">
                                                    <label>پیوست</label>
                                                    <input type="file" className="form-control" ref={commandAttachment} />
                                                </div>
                                            }
                                            <div className="form-group col-md-4">
                                                <label>موضوع دستور کار</label>
                                                <input className="form-control" type="text" defaultValue={currCommandID.current === "0" || !command ? "" : command.Subject}
                                                    onChange={(e) => commandData.current.Subject = e.target.value} />
                                                {err.Subject && <small className="errors">موضوع دستور کار الزامی است</small>}
                                            </div>
                                            <div className="form-group col-md-8">
                                                <label>متن دستور کار</label>
                                                <Form.Control as="textarea" style={{ fontSize: "13px" }} rows={1} defaultValue={currCommandID.current === "0" || !command ? "" : command.Message}
                                                    onChange={(e) => commandData.current.Message = e.target.value} />
                                                {err.Message && <small className="errors">متن دستور کار الزامی است</small>}
                                            </div>
                                        </div>
                                        <div>
                                            {currCommandID.current === "0" &&
                                                <Button className="mt-1 group-Btn-smalll" onClick={showUserPop}><PersonLinesFill size={14} />&nbsp;دریافت کننده ها </Button>
                                            }
                                            <Button className="mt-1 group-Btn-smalll btn-success" onClick={saveCommand}><Check2 size={14} />&nbsp;ثبت اطلاعات</Button>
                                            {currCommandID.current !== "0" && !command?.IsDone &&
                                                <Button className="mt-1 group-Btn-smalll" onClick={changeCommand2Done}><Check2Square size={14} />&nbsp;انجام شد</Button>
                                            }
                                            {err.Recipients && <small style={{ display: "block" }} className="errors">لیست دریافت کنندگان خالی است</small>}
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                        {currCommandID.current !== "0" && command &&
                            <Fragment>
                                <label className="mt-3">پیام ها</label>
                                &nbsp;
                                <PlusCircle size={18} style={{ cursor: "pointer" }} color="red" onClick={() => setNewShow(true)} />
                                {command.AttachmentFileName && command.AttachmentFileName.length > 0 &&
                                    <Link45deg size={23} style={{ float: "left", marginTop: "10px", color: "blue", cursor: "pointer" }} onClick={() => downloadFile(command.CommandMessageID, "command")} />
                                }
                                <PersonLinesFill size={21} style={{ float: "left", marginTop: "10px", color: "#b700ff", cursor: "pointer" }} onClick={showUserPop} />
                                <hr style={{ margin: "0px" }} />

                                <div className="row" style={{ display: showNew ? "flex" : "none", overflow: "hidden" }}>
                                    <div className="form-group">
                                        <label>متن پیام</label>
                                        <Form.Control as="textarea" style={{ fontSize: "13px" }} onChange={(e) => messageData.current.Message = e.target.value} rows={3} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>پیوست</label>
                                        <input className="form-control" style={{ fontSize: "13px" }} type="file" ref={messageAttachment} />
                                    </div>
                                    <div className="mt-2 mb-2">
                                        <Button className="group-Btn" onClick={addMessage}>ثبت پیام</Button>
                                        <Button className="group-Btn btn-danger" onClick={() => setNewShow(false)}>انصراف</Button>
                                    </div>
                                </div>
                                {command && command.CommandMessages && command.CommandMessages.length > 0 &&
                                    <div className="mt-1" style={{ overflowY: "scroll", overflowX: "hidden", maxHeight: "40vh", display: showNew ? "none" : "block" }}>

                                        <Fragment>
                                            {command.CommandMessages === "PENDING" && <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={40} />}
                                            {Array.isArray(command.CommandMessages) && command.CommandMessages.map((item, i) =>
                                                <div key={i} className="row">
                                                    <Card className="mt-1">
                                                        <Card.Header style={{ backgroundColor: i % 2 === 0 ? "rgb(151 179 223)" : "#ced5e0" }}>
                                                            <PersonCircle />
                                                            &nbsp;
                                                            <span>{item.CreateByName}</span>
                                                            &nbsp;
                                                            <span style={{ color: "#575555", fontSize: "10px" }}>{item.CreationHour + " " + item.pCreationDate} </span>
                                                            &nbsp;
                                                            {item.AttachmentFileName && item.AttachmentFileName.length > 0 &&
                                                                <Link45deg size={20} color="blue" style={{ cursor: "pointer" }} onClick={() => {
                                                                    downloadFile(item.ID, "command");
                                                                }} />}
                                                            &nbsp;
                                                            {item.CanDelete &&
                                                                <Trash color="red" style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        dispatch(setDialog({
                                                                            status: 'show',
                                                                            arrayBtn: ['yes', 'no'],
                                                                            dialogTitle: 'حذف پیام',
                                                                            dialogText: 'آیا از حذف مطمئن هستید؟',
                                                                            okOperation: deleteMessage(item.ID, () => onDeleteSuccess(item.ID))
                                                                        }))
                                                                    }
                                                                    }
                                                                />}
                                                        </Card.Header>
                                                        <Card.Body >
                                                            <Form.Control as="textarea" style={{ fontSize: "13px" }} rows={2} defaultValue={item.Message} />
                                                        </Card.Body>
                                                    </Card>
                                                </div>

                                            )
                                            }
                                        </Fragment>


                                    </div>}
                            </Fragment>
                        }
                    </Fragment>
                }
            </Modal.Body>
        </Modal>
    )
}
export default Commands;